import React from "react";
import GlassCard from "../../components/GlassCard";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import Warning from "./Warnings";
import { getCurrentConsent } from "../api/intakeApi";
import { beforeFormTranslations } from "../data/beforeFormTranslations";
import { useState } from "react";
import { editPlanText } from "../data/platformText";
import { userProfilePageContent } from "../data/userProfilePageContent";
import { connectToPlanByPublicId } from "../api/planApi";
const BeforeForm = () => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();
  const t = beforeFormTranslations[currentLang] || beforeFormTranslations.en;
  const l = editPlanText[currentLang];
  const f = userProfilePageContent[currentLang];
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [planCode, setPlanCode] = useState("");
  const [message, setMessage] = useState("");
  const [loading_id, setLoading_id] = useState(false);
  const goForm = async () => {
    try {
      const result = await getCurrentConsent();
      console.log("result:", result);
      console.log("typeof granted:", typeof result?.granted, result?.granted);

      navigate(
        result?.granted === false
          ? `/${currentLang}/platform/health_consent`
          : `/${currentLang}/platform/form`
      );
    } catch (error) {
      console.error("Failed to fetch consent:", error);
      navigate(`/${currentLang}/platform/health_consent`);
    }
  };

  const handleConnectPlan = async () => {
      try {
      setLoading_id(true);
      setError("");
      setMessage("");

      const data = await connectToPlanByPublicId(planCode);
      setMessage(data.message || "Plan connected successfully");
      setPlanCode("");
      } catch (err) {
      setError(err.message || "Failed to connect to plan");
      } finally {
      setLoading_id(false);
      }
  };

  return (
    <div className="main-platform-shell">
      <GlassCard
        style={{
          padding: "10px",
          maxWidth: "775px",
          marginLeft: "50px",
          marginBottom: "25px",
        }}
      >
        <div
          style={{
            fontSize: "0.8rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            opacity: 0.7,
          }}
        >
          {t.platformLabel}
        </div>
        <h1>{t.welcomeTitle}</h1>
        <p>{t.welcomeDescription}</p>
      </GlassCard>

      <GlassCard style={{ padding: "10px", maxWidth: "775px", marginLeft: "50px" }}>
        <div
          style={{
            fontSize: "0.8rem",
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            opacity: 0.7,
          }}
        >
          {t.requiredLabel}
        </div>
        <h2>{t.intakeTitle}</h2>
        <p>{t.intakeDescription}</p>
        <h1></h1>
        <h2>{t.physioTitle}</h2>
        <p>{t.physioDescription}</p>
      </GlassCard>

      <GlassCard style={{padding: "20px",borderRadius: "24px",marginTop: "24px",marginLeft: "50px",marginBottom: "24px",}}>
        <div
            style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
            alignItems: "center", 
            justifyContent: "space-between",
            }}>
            <div>
            <div
                style={{
                fontWeight: 700,
                fontSize: 20,
                marginBottom: 4,
                }}>
                {l.costumPlan}
            </div>
            
            </div>
            <div>
                <input
                    type="text"
                    value={planCode}
                    onChange={(e) => setPlanCode(e.target.value.toUpperCase())}
                    style={{
                    background: "#EEF5FF",
                    width: "200px",
                    height: "35px",
                    borderRadius: "10px",
                    paddingLeft: "10px",
                    borderColor: "#176B87",
                    }}
                    placeholder="AB-123-456-789"
                />

                <button type="button" onClick={handleConnectPlan} disabled={loading_id}>
                    {loading_id ? f.connecting : f.connect}
                </button>

                {message && <div style={{ color: "green", marginTop: "10px" }}>{message}</div>}
                {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
            </div>
            </div>
        </GlassCard>

      <Warning warningType="MissingPersonalInfo" />

      <Warning warningType="NoActivePlanForUser"/>
    </div>
  );
};

export default BeforeForm;